import React, { Dispatch, SetStateAction, useEffect, useState } from "react";

import { Modal } from "./Modal";

import { HeaderModal } from "./Header";
import { Body } from "./Body";
import { FooterModal } from "./Footer";

import closeIcon from "assets/images/close-icon.svg";
import modalBgShade from "../../../assets/images/bg-modal-shade.svg";
import allImgPaths from "assets/images";
import { Link } from "react-router-dom";
import { getVenueDetails, updateVenue } from "services/event";
import { MAP_API_KEY } from "utils/constant";
import { ExistingSettingMemberLoader } from "components/loaders";

interface Iprops {
  data: any,
  setShowDetailsModal: any;
}
let imageGalleryInit: any = {
  mainImage: allImgPaths.dummyImg1,
  thumbnailImages: [
    allImgPaths.dummyImg1,
    allImgPaths.dummyImg1,
    allImgPaths.dummyImg1,
    allImgPaths.dummyImg1
  ]
};

let overViewInitData = [
  {
    property: 'Chain',
    value: 'IHG'
  },
  {
    property: 'Built',
    value: '1989'
  },
  {
    property: 'Total Meeting Space',
    value: '25,000 sq ft'
  },
  {
    property: 'Venue Type',
    value: 'Hotel'
  },
  {
    property: 'Brand',
    value: 'Crowne Plaza Hotels'
  },
  {
    property: 'Renovated',
    value: '2015'
  },
  {
    property: 'Guest Rooms',
    value: '795'
  }
]

const amenitiesInit = [
  {
    name: 'Room features and guest services',
    values: [
      'Concierge services',
      'Internet access',
      'Laundry service',
      'Luggage storage',
      'Room service',
      'View (ocean or water)',
      'View (urban)',
      'Voicemail box'
    ]
  },
  {
    name: 'Facilities',
    values: [
      'Onsite catering',
      'Onsite gift shop',
      'Onsite restaurant',
      'Onsite security',
      'Pet friendly',
      'Space (private)',
      'Space (semi-private)',
      'Wheelchair accessible'
    ]
  },
  {
    name: 'Business services',
    values: [
      'AV capabilities',
      'Business center',
      'Video conference',
      'VIP services'
    ]
  },
  {
    name: 'Venue accessibility',
    values: [
      'Airport shuttle',
      'Bus',
      'Subway',
      'Taxi',
      'Train'
    ]
  },
  {
    name: 'Equipment',
    values: [
      'Dance floor',
      'Portable walls',
      'Staging area'
    ]
  }
]

const roomDetailsInitData = [
  {
    property: 'Meeting Rooms',
    value: '28'
  },
  {
    property: 'Largest Room',
    value: '6780 sq. ft.'
  },
  {
    property: 'Second Largest Room',
    value: '6273  sq ft'
  },
  {
    property: 'Private Space',
    value: '23,500 sq. ft'
  },
  {
    property: 'Semi Private Space',
    value: '3,000 sq. ft.'
  },
  {
    property: 'Exhibit Space',
    value: '8,000 sq. ft.'
  },
  {
    property: 'Total guest Rooms',
    value: '795'
  },
  {
    property: 'Single Bed',
    value: '397'
  },
  {
    property: 'Double Beds',
    value: '392'
  },
  {
    property: 'Suites',
    value: '5'
  },
  {
    property: 'Tax Rate',
    value: '14.75%'
  },
]


function VendorDetailsModal({ data: dataObj, setShowDetailsModal }: Iprops) {
  const [isLoading, setIsLoading] = useState(false)
  const [venueData, setVenueData] = useState<any>(null)
  const [imageGallery, setImageGallery] = useState<any>(null);
  const [overviewData, setOverViewData] = useState<any>([]);
  const [amenities, setAmenitiesData] = useState<any>([])
  const [roomDetailsData, setRoomDetailsData] = useState<any>([])

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    setIsLoading(true)
    const payload = {
      title: dataObj.title,
      venue_id: dataObj?.venueId

      // title: 'Kimpton Hotel Eventi',
      // venue_id: '6683d49931992da613725178'
    }

    try {
      const { data } = await getVenueDetails(payload);
      const updatedData = updateVenueData(data)
      setVenueData(updatedData);

      console.log({ venueData: updatedData })

      setElementsData(data);
      setIsLoading(false)
    } catch (error) {
      console.log({ venueError: error })
      setVenueData(null)
      setIsLoading(false)
    }
  }

  const updateVenueData = (data: any) => {
    if (!data?.map_url && data?.address) {
      const encodedAddress = encodeURIComponent(data.address);
      const mapUrl = `https://www.google.com/maps/embed/v1/place?key=${MAP_API_KEY}&q=${encodedAddress}`;
      data['map_url'] = mapUrl;
    }
    return data
  }

  // const setMapData = async (data: any) => {
  //   const payload = {
  //     id: data?._id,
  //     city: data?.city,
  //     title: data?.title,
  //     map_url: data.map_url
  //   }

  //   await updateVenue(payload)
  // }

  const setElementsData = (data: any) => {
    if (data?.images) {

      const imageGalleryData = {
        mainImage: data.images[0],
        thumbnailImages: [
          data.images[1],
          data.images[2],
          data.images[3],
          data.images[4]
        ]
      };

      setImageGallery(imageGalleryData)
    }

    const overViewDataSetup = [
      { property: 'Chain', value: data?.chain },
      { property: 'Built', value: data?.built },
      { property: 'Total Meeting Space', value: data?.total_meeting_space },
      { property: 'Venue Type', value: data?.venue_types },
      { property: 'Brand', value: data?.brand },
      { property: 'Renovated', value: data?.renovated },
      { property: 'Guest Rooms', value: data?.guest_rooms }
    ]
    setOverViewData(overViewDataSetup)

    setAmenitiesData(data?.amenity || [])

    const roomDetailsDataSetup = [
      { property: 'Meeting Rooms', value: data?.meeting_rooms || '-' },
      { property: 'Largest Room', value: data?.largest_room || '-' },
      { property: 'Second Largest Room', value: data?.second_largest_room || '-' },
      { property: 'Private Space', value: data?.private_space || '-' },
      { property: 'Semi Private Space', value: data?.semi_private_space || '-' },
      { property: 'Exhibit Space', value: data?.exhibit_space || '-' },
      { property: 'Total guest Rooms', value: data?.total_guest_rooms || '-' },
      { property: 'Single Bed', value: data?.single_bed || '-' },
      { property: 'Double Beds', value: data?.double_beds || '-' },
      { property: 'Suites', value: data?.suites || '-' },
      { property: 'Tax Rate', value: data?.tax_rate || '-' }
    ]
    setRoomDetailsData(roomDetailsDataSetup)

  }

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
  }

  const handleImageError = (e: any) => {
    e.target.src = allImgPaths.noImage
  }

  return (
    <>
      <Modal className={"modal-wrapper max-w-[856px]"} isShow={setShowDetailsModal}>
        <form onSubmit={handleSubmit}>

          <HeaderModal title={"test"} isShowHeader={true} className="modal-header pt-6 px-6">

            <div className="flex items-center justify-between">
              <h2 className="text-lg text-[#101828] font-interSemiBold leading-none pb-1.5">
                Vendor Details
              </h2>
              {/* Close Icon */}
              <img
                className="modal-close modal-toggle cursor-pointer hover:bg-[#f2f4f7] rounded w-5 p-1"
                id="modal-toggle"
                src={closeIcon}
                onClick={() => { setShowDetailsModal(false) }}
                alt="close icon"
              />
            </div>

          </HeaderModal>

          <Body title="" isShowBody={true} className="modal-body px-6 pt-5">
            {isLoading && <ExistingSettingMemberLoader />}
            {
              !isLoading &&
              !venueData &&
              <div>Details not Available</div>
            }
            {
              !isLoading &&
              venueData &&
              <div className="max-h-[calc(100vh_-_240px)] overflow-y-auto pr-2 transparent-scrollbar">

                {/* Images */}
                {
                  imageGallery &&
                  <div className="flex gap-x-2 border rounded-lg p-2 border-[#EAECF0] mb-6">
                    {
                      imageGallery?.mainImage &&
                      <img className="rounded-lg w-96 h-96 object-cover" src={imageGallery.mainImage} onError={handleImageError} alt="" />
                    }

                    {
                      imageGallery?.thumbnailImages?.length > 0 &&
                      <div className="flex gap-2 flex-wrap">
                        {
                          imageGallery.thumbnailImages.map((imgs: any, ind: number) => (
                            <div key={ind} className="w-[188px] h-[188px] rounded-lg">
                              <img className="rounded-lg w-full h-full object-cover" src={imgs} onError={handleImageError} alt="" />
                            </div>
                          ))
                        }
                      </div>
                    }
                  </div>
                }

                {/* Names */}
                <div className="mb-6">
                  <div className="flex items-center justify-between mb-2.5">
                    <p className="text-xl font-interMedium text-[#101828]">
                      {venueData?.title}
                    </p>
                  </div>

                  <div className="flex items-center justify-between">
                    {venueData?.address &&
                      <p className="flex items-center gap-x-2 mb-1.5 text-[#667085]">
                        <img className="w-5 h-5" src={allImgPaths.locationIcon} alt="" />
                        {venueData?.address}
                      </p>
                    }

                    {
                      venueData?.website &&
                      <a href={venueData?.website} target="_blank" className="font-interMedium text-sm text-[#1E0AF5] hover:text-[#0C0462] flex items-center gap-x-2 w-1/2">
                        <img className="w-6 h-6" src={allImgPaths.outLinkIcon} alt="" />
                        {venueData?.website}
                      </a>
                    }
                  </div>
                </div>

                {/* Overview */}
                {
                  overviewData?.length > 0 &&
                  <div className="mb-5 border-b border-[#E5E7EB] pb-6">
                    <p className="text-xl font-interMedium text-[#101828] mb-2">Overview</p>
                    <div className="flex flex-wrap gap-y-5">
                      {
                        overviewData.map((overview: any, oIndex: number) => (
                          <div key={oIndex} className="w-1/4">
                            <p className="text-sm text-[#667085] pb-1.5">{overview.property}</p>
                            <p className="text-sm font-interSemiBold text-[#344054]">{overview.value}</p>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                }

                {/* Awards */}
                {
                  venueData?.awards &&
                  <div className="mb-5 border-b border-[#E5E7EB] pb-6">
                    <p className="text-xl font-interMedium text-[#101828] mb-2">Awards</p>
                    <div className="">
                      {/* <p className="text-sm text-[#667085] pb-1.5">2017</p> */}
                      <p className="text-sm font-interSemiBold text-[#344054]">{venueData?.awards}</p>
                    </div>
                  </div>
                }

                {/* Amenities */}
                {
                  amenities?.length > 0 &&
                  <div className="mb-5 border-b border-[#E5E7EB] pb-6">
                    <p className="text-xl font-interMedium text-[#101828] mb-2">Amenities</p>
                    <div className="flex flex-wrap gap-y-5">
                      {
                        amenities.map((amenity: any, aIndex: number) => (
                          <div className="w-1/3" key={aIndex}>
                            <p className="text-sm text-[#667085] pb-1.5">{amenity.name}</p>
                            <ul className="list-disc pl-6">
                              {amenity.values.map((value: any, vi: number) => (
                                <li key={vi} className="text-[#000000]">{value}</li>
                              ))}
                            </ul>
                          </div>
                        ))
                      }

                    </div>
                  </div>
                }

                {/* Distance */}
                {
                  venueData?.distance_from_airport &&
                  <div className="mb-5 border-b border-[#E5E7EB] pb-6">
                    <p className="text-xl font-interMedium text-[#101828] mb-2">Distance from airport</p>
                    <div className="">
                      <p className="text-sm text-[#667085] pb-1.5">{venueData?.distance_from_airport}</p>
                    </div>
                  </div>
                }

                {/* Room Details */}
                {
                  roomDetailsData?.length > 0 &&
                  <div className="mb-5 border-b border-[#E5E7EB] pb-6">
                    <p className="text-xl font-interMedium text-[#101828] mb-2">Room Details</p>
                    <div className="flex flex-wrap gap-y-5">
                      {
                        roomDetailsData.map((roomDetail: any, rIndex: number) => (
                          <div className="w-1/4" key={rIndex}>
                            <p className="text-sm text-[#667085] pb-1.5">{roomDetail.property}</p>
                            <p className="text-sm font-interSemiBold text-[#344054]">{roomDetail.value}</p>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                }

                {/* Parkings */}
                {
                  venueData?.parkings?.length > 0 &&
                  <div className="mb-5 border-b border-[#E5E7EB] pb-6">
                    <p className="text-xl font-interMedium text-[#101828] mb-2">Parking</p>
                    <div className="">
                      <ul className="list-disc pl-[18px]">
                        {
                          venueData.parkings.map((pk: any, pIndex: number) => (
                            <li className="text-sm font-interSemiBold text-[#344054] pb-1" key={pIndex}>{pk}</li>
                          ))
                        }
                      </ul>
                    </div>
                  </div>
                }

                {/* Nearby */}
                <div className="mb-5 border-b border-[#E5E7EB]">
                  {
                    venueData?.map_url &&
                    <>
                      <p className="text-xl font-interMedium text-[#101828] mb-3">Nearby</p>
                      <iframe
                        // src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15282225.79979123!2d73.7250245393691!3d20.750301298393563!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30635ff06b92b791%3A0xd78c4fa1854213a6!2sIndia!5e0!3m2!1sen!2sin!4v1587818542745!5m2!1sen!2sin"
                        src={venueData?.map_url}
                        width="100%"
                        height="500"
                        style={{ "borderRadius": "4px", "border": "2px solid #E5E7EB", "marginBottom": "20px" }}
                        aria-hidden="false"
                      />
                    </>
                  }
                  {
                    venueData?.more_info &&
                    <p className="text-sm text-[#344054] pb-6">{venueData.more_info}</p>
                  }
                </div>

                {/* Cancellation Policy */}
                {
                  venueData?.cancellation_policy &&
                  <div className="mb-5">
                    <p className="text-xl font-interMedium text-[#101828] mb-2">Cancellation Policy</p>
                    <div className="">
                      <p className="text-sm text-[#344054] pb-1.5">
                        {venueData?.cancellation_policy}
                      </p>
                    </div>
                  </div>
                }

              </div>
            }
          </Body>

          <FooterModal title="" isShowFooter={true} className="modal-footer pt-8 px-6 pb-4">
            <div className=""></div>
          </FooterModal>
        </form>
      </Modal>
    </>
  );
}

export default VendorDetailsModal;
